import { type BaseNodeData } from '../types';
import { BaseNode } from './BaseNode';
import { nodeStyles } from './styles';

interface EmailNodeProps {
	data: BaseNodeData;
	selected?: boolean;
}

export function EmailNode({ data, selected }: EmailNodeProps) {
	return (
		<BaseNode
			data={data}
			selected={selected}
			containerStyle={nodeStyles.emailContainer}
			targetPosition={data.targetPosition}
			sourcePosition={data.sourcePosition}
			icon={
				<svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
					<rect x='2' y='4' width='12' height='8' rx='2' stroke='#3b82f6' strokeWidth='1.5' fill='none' />
					<path d='M2 6l6 4 6-4' stroke='#3b82f6' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
				</svg>
			}
		/>
	);
}
